(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about"] && !Shopify.designMode) return;
  try {
    



    $(document).ready(function ()
    {

    DBL.scrolls.init();

    })




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["al-faq-cat"]) return;
  try {
    
DBL.faq.init();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-hero"] && !Shopify.designMode) return;
  try {
    

    DBL.faq.init();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index_hero_slider"] && !Shopify.designMode) return;
  try {
    



    $(document).ready(function ()
    {
    DBL.hero.init();
    })




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index_hero_slider_new"] && !Shopify.designMode) return;
  try {
    



    $(document).ready(function ()
    {
    DBL.hero.init();
    })




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-bundle"]) return;
  try {
    
    $(document).ready(function ()
    {
        DBL.product.init();
        DBL.product.bundle();
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-group-1"]) return;
  try {
    

    $(document).ready(function ()
    {
    DBL.product.init();
    DBL.product.upsells();

    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-sup"]) return;
  try {
    

    $(document).ready(function ()
    {
    DBL.product.init();
    DBL.product.upsells();

    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    

    $(document).ready(function ()
    {
    DBL.product.init();
    DBL.product.upsells();

    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zpor-index_hero_video"] && !Shopify.designMode) return;
  try {
    



$(document).ready(function ()
{
DBL.hero.init();
})




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zpor-plus-image-hero"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function ()
{
DBL.hero.init();
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zpor-plus-vide-hero"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function ()
{
DBL.hero.init();
})

  } catch(e) { console.error(e); }
})();
})();
